import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Tab } from '@finder/shared/components/tab/tab.interface';
import { ScrollToDirective } from '@finder/shared/directives/scroll-to/scroll-to.directive';
import { IdGeneratorPipe } from '@finder/shared/utils/pipes/id-generator/id-generator.pipe';
import { KebabCasePipe } from '@finder/shared/utils/pipes/kebab-case/kebab-case.pipe';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ImageDrawerComponent } from '../image-drawer/image-drawer.component';
import { ImageBlockComponent } from '../image-block/image-block.component';
import { GenericTextComponent } from '../generic-text/generic-text.component';
import { CampaignDrawerGroupComponent } from '../campaign-drawer-group/campaign-drawer-group.component';
import { CampaignDrawerGroupMultiRowComponent } from '../campaign-drawer-infographic-multi-row/campaign-drawer-group-multi-row.component';

@Component({
    selector: 'finder-tab-content-renderer',
    templateUrl: './tab-content-renderer.component.html',
    styleUrls: ['./tab-content-renderer.component.scss'],
    standalone: true,
    imports: [
        KebabCasePipe,
        CommonModule,
        ScrollToDirective,
        IdGeneratorPipe,
        ImageDrawerComponent,
        ImageBlockComponent,
        GenericTextComponent,
        CampaignDrawerGroupComponent,
        CampaignDrawerGroupMultiRowComponent
    ]
})
export class TabContentRendererComponent implements OnInit, OnDestroy {
    @Input() panels: any;
    @Input() activeTab: Tab;
    @Input() tabIdPrefix: string;
    @Input() parentId: string;
    @Input() tabChange: Observable<Tab>;

    destroy$ = new Subject<void>();

    ngOnInit(): void {
        if (!this.tabChange) {
            return;
        }

        this.tabChange
            .pipe(takeUntil(this.destroy$))
            .subscribe(tab => {
                this.activeTab = tab;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
